import styled from "styled-components";
import { space, color, layout, typography } from "styled-system";
import propTypes from "@styled-system/prop-types";
import { themeGet } from "@styled-system/theme-get";
import { Text } from "../../style/Text";

const FilterClear = styled(Text)`
  position: relative;
  padding-right: 15px;
  text-decoration: underline;
  cursor: pointer;

  @media screen and (max-width: ${themeGet("breakpoints.md")}) {
    padding-right: 15px;
  }

  &:after {
    content: "\\00d7";
    position: absolute;
    top: 0;
    right: 0;
  }
`;

FilterClear.displayName = `span`;

FilterClear.defaultProps = {
  fontSize: "14px",
};

export { FilterClear };
